export const TOUR_OPERATOR_REVIEW_DETAIL_START = "TOUR_OPERATOR_REVIEW_DETAIL_START";
export const TOUR_OPERATOR_REVIEW_DETAIL_SUCCESS = "TOUR_OPERATOR_REVIEW_DETAIL_SUCCESS";
export const TOUR_OPERATOR_REVIEW_DETAIL_ERROR = "TOUR_OPERATOR_REVIEW_DETAIL_ERROR";